import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const DeliveryFeesDeliveryChargeFragmentDoc = gql`
  fragment DeliveryFeesDeliveryCharge on DeliveryCharge {
    id
    deliveryChargeExTax
    deliveryChargeTaxPercentage
    minimumOrderValueExTax
  }
` as unknown as DocumentNode<Types.DeliveryFeesDeliveryChargeFragment, unknown>
